import { render, staticRenderFns } from "./trade_rules.vue?vue&type=template&id=7a772327&"
import script from "./trade_rules.vue?vue&type=script&lang=js&"
export * from "./trade_rules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports